import React, { useState, useEffect } from 'react';
import { useData } from '../contexts/DataContext';
import { FollowRelation } from '../types/firebase';
import Pill from './Pill';

interface FollowingListProps {
  userId: string;
}

export default function FollowingList({ userId }: FollowingListProps) {
  const [following, setFollowing] = useState<FollowRelation[]>([]);
  const [loading, setLoading] = useState(true);
  const { getUserFollowing } = useData();

  useEffect(() => {
    const fetchFollowing = async () => {
      try {
        const followingData = await getUserFollowing(userId);
        setFollowing(followingData);
      } catch (error) {
        console.error('Error fetching following:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFollowing();
  }, [userId]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {following.map((follow) => (
        <div 
          key={follow.following_id} 
          className="flex items-center p-4 border rounded-lg hover:shadow-md transition-shadow"
          onClick={() => window.location.href = `/practitioners/view?id=${follow.following_id}`}
        >
          <img 
            src={follow.following_logo} 
            alt={follow.following_name}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div className="ml-4">
            <h3 className="font-medium">{follow.following_name}</h3>
            <div className="flex flex-wrap gap-1 mt-2">
              {follow.following_types?.map((type) => (
                <Pill
                  key={type}
                  text={type}
                  colorClass="bg-muted-grey"
                  size="small"
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
} 